var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".j{fill:url(#h);}.k{fill:url(#i);}.l{fill:url(#f);}.m{fill:url(#g);}.n{fill:url(#e);}.o{clip-path:url(#d);}.o,.p{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -269.23,
    y1: 25.07,
    x2: 976.43,
    y2: 25.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a9eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0b8ccd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ec3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 883.92,
    y1: 1055.56,
    x2: 1824.93,
    y2: 1055.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d62ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#144391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13.6,
    y1: 1144.32,
    x2: 873,
    y2: 284.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d62ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#1667b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ec3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 877.92,
    y1: 258.4,
    x2: 1864.15,
    y2: 258.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f9b233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f6a038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ed694b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 1243.21,
    y1: 1117.53,
    x2: 1993.05,
    y2: 488.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e72f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ed694b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "0 -138.79 0 188.93 1197.17 104.52 1197.17 -138.79 0 -138.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m461.68,1218.79h973.98c-105.91-76.41-167.23-190.93-201.08-326.46l-772.9,326.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m0,188.93v1029.86h461.68l772.9-326.46c-27.89-110.97-37.41-236.88-37.41-366.73V104.52L0,188.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m815.33-138.79c3.19,20.02,7.03,40.21,11.53,60.54,61.72,285.18,125.51,508.74,169.42,733.84l923.72-129.93V-138.79H815.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m996.28,655.59c34.59,175.88,57.31,354.27,57.54,563.2h866.18v-693.13l-923.72,129.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.d6b6845dbacf4fa1b89b561b9c40f674.svg";
export { ForwardRef as ReactComponent };